var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.embedUrl)?_c('figure',{staticClass:"generic-video youtube-video"},[_c('div',{staticClass:"embed-video"},[_c('div',{staticClass:"container youtube-container"},[_c('iframe',{attrs:{"src":_vm.embedUrl,"title":_vm.title,"frameborder":"0"}})])]),_vm._v(" "),(_vm.caption)?_c('figcaption',[_vm._v(_vm._s(_vm.caption))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }